import React, { useEffect } from 'react'
import { isLoggedIn } from '../utils'
import { Outlet, useNavigate } from 'react-router-dom'
import SideDrawer from './Drawer'
import { Grid, makeStyles } from '@material-ui/core'
import AppBarComp from './AppBar'
import CopyRight from './Copyright'

const useStyles = makeStyles((theme) => {
    return {
        root: {

        }
    }
});

export const ProtectedRoutes = () => {
    const navigate = useNavigate()
    const classes = useStyles()

    useEffect(() => {
        const isUserLoggedIn = isLoggedIn()

        if (!isUserLoggedIn) return navigate('/login')
    }, [isLoggedIn()])

    return (
        <Grid container >
            <AppBarComp />
            <Grid item className={classes.root} >
                <SideDrawer />
            </Grid>
            <Outlet />
            <CopyRight />
        </Grid>
    )
}
